import { render, staticRenderFns } from "./normal-home.vue?vue&type=template&id=1e652722&scoped=true"
import script from "./normal-home.vue?vue&type=script&lang=js"
export * from "./normal-home.vue?vue&type=script&lang=js"
import style0 from "./normal-home.vue?vue&type=style&index=0&id=1e652722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e652722",
  null
  
)

export default component.exports